import type { PropsWithChildren } from "react";
import { useCurrentUser } from "@for-it/web-lib";
import { UserRole } from "app-domain";
import Footer from "../components/footer.tsx";
import IconContact from "../components/icon-contact.tsx";

export default function HomeLayoutWithoutSidebar({
    children,
}: PropsWithChildren) {
    const currentUser = useCurrentUser();

    return (
        <div className="flex min-h-screen flex-col">
            <header className="w-full bg-[#9C9C9A]">
                <div className="w-full py-6 px-8 flex items-center">
                    <img
                        src="https://www.saaf.org.ar/wp-content/uploads/2024/11/logosaaf.webp"
                        alt="Logo"
                        className="h-12 w-auto"
                    />
                </div>
            </header>
            <main className="flex-1">{children}</main>
            {currentUser?.role !== UserRole.ADMIN && <IconContact />}
            <Footer />
        </div>
    );
}
